import React, {useState} from 'react';
import logo from '../../../../../assets/security-details-upload-order-list.svg';
import styles from './upload-orders-list.module.scss';
import ModalCustom from "../../../../../components/modal/modal";
import UploadOrdersModalContent from "../modal-content-upload-orders/modal-content-upload-orders";


const UploadOrdersList = ({security}) => {
  const action = 'Upload Reservation List';
  const [show, setShow] = useState(false);
  const onClose = () => setShow(false);

  return (
    <>
      <div onClick={() => setShow(true)} className={styles['logo']}>
        <img alt={action} src={logo} />
        <label>{action}</label>
      </div>
      <ModalCustom
        show={show}
        title={action}
        onClose={onClose}
        component={renderModalContent(security)}
        style={styles['upload-orders-modal']}
      />
    </>
  );
}

const renderModalContent = (security) => {
  return (
    <div className={styles['upload-section']}>
      <UploadOrdersModalContent security={security}/>
    </div>
  )
}


export default UploadOrdersList;
